import React from "react";
import { useNavigate } from "react-router-dom";
import { MainSection, Section, SectionTitle, SectionTitleRow } from "../common_components/Layout";
import CenteredLoadingIcon from "../common_components/CenteredLoadingIcon";
import { MissionCardTitleRow, MissionCards, EmptyMissionsCard } from "./MissionCardComponents";
import { TertiaryLink } from "../common_components/Buttons";



function MissionsSection(props) {
    const navigate = useNavigate();
    // Get the count of props.missions where props.mission.status != "draft"
    // const launchedMissionsCount = props.missions.filter(mission => mission.status != "draft").length;

    const SwitchMissionSection = props.missions.length == 0 ?
        <EmptyMissionsCard />
        :
        <div className="mission-card-section-container">
            {/* <MissionCardTitleRow /> */}
            <MissionCards missions={props.missions} updateMissions={props.updateMissions} />
        </div>

    return (
        <Section>
            <SectionTitleRow>
                <SectionTitle title="Projects" />
                <TertiaryLink text="Create New" onClick={() => navigate("/createmission")} />
            </SectionTitleRow>
            {props.loadMissionsComplete ? SwitchMissionSection : <CenteredLoadingIcon />}
        </Section>
    )

}

export default MissionsSection;